import { getSystemState } from "@/features/system-states/system-state";
import { SystemStatePage } from "@/features/system-states/system-state-page";
import SysEmpty from "@/features/system-states/sys-empty";

export default function EmptyPage() {
  return (
    <SystemStatePage meta={getSystemState("SYS-01")}>
      <SysEmpty />
    </SystemStatePage>
  );
}
